import { AuthType, UserRoleType } from '@ovpn-ui-toolkit/mf-common';

import { EnumValue } from '../utils/utility.types';

import { ConnectionStatus } from './status';
import { GroupSimple } from './group';

export const MemberStatus = {
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED',
    SuspendedIdp: 'SUSPENDED_IDP',
    Invited: 'INVITED',
    friendlyString(entry: string): string {
        const map = {
            [this.Active]: 'Active',
            [this.Suspended]: 'Suspended',
            [this.SuspendedIdp]: 'Suspended',
            [this.Invited]: 'Created',
        };
        return map[entry as unknown as keyof typeof map] || entry;
    },
} as const;

export const MemberRole = {
    Owner: 'OWNER',
    Admin: 'ADMIN',
    Member: 'MEMBER',
    friendlyString(entry: string): string {
        const map = {
            [this.Owner]: 'Owner',
            [this.Member]: 'Member',
            [this.Admin]: 'Admin',
        };
        return map[entry as unknown as keyof typeof map] || entry;
    },
} as const;

export type AuthTypeValue = EnumValue<typeof AuthType>;
export type MemberRoleValue = EnumValue<typeof MemberRole>;
export type UserRoleTypeValue = EnumValue<typeof UserRoleType>;
export type MemberStatusValue = EnumValue<typeof MemberStatus>;

export type Member = {
    id: string;
    username: string;
    superMember: boolean;
    role: MemberRoleValue;
    authType: AuthTypeValue;
    status: MemberStatusValue;
    connectionStatus: ConnectionStatus;

    email?: string;
    firstName?: string;
    lastName?: string;
    temporaryPassword?: string;

    group: GroupSimple;
};

export const MemberRoleOptions = [MemberRole.Owner, MemberRole.Admin, MemberRole.Member].map(t => ({
    name: MemberRole.friendlyString(t),
    value: t,
}));
